"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANUFACTURER = exports.LENDER = exports.INCLUDED = exports.DEALER_CASH = void 0;
exports.DEALER_CASH = 'Dealer Cash';
exports.INCLUDED = 'Included';
exports.LENDER = 'Lender';
exports.MANUFACTURER = 'Manufacturer';
